/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class ContractTypes<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Obtiene los tipos de contratos disponibles para análisis
   *
   * @tags contracts
   * @name GetContractTypesContractTypesGet
   * @summary Tipos de Contratos
   * @request GET:/contract-types
   */
  getContractTypesContractTypesGet = (params: RequestParams = {}) =>
    this.request<Record<string, string[]>, any>({
      path: `/contract-types`,
      method: "GET",
      format: "json",
      ...params,
    });
}
